import React from "react";

const WomenEmpowerment = () => {
  return <div>Women Empowerment</div>;
};

export default WomenEmpowerment;
